import {
	mapActions,
	mapGetters
} from 'vuex';

import {
	isEmpty
} from 'lodash';

import moment from 'moment';

import {
	cloneDeep
} from 'lodash';

import {
	EventBus
} from '@/support/event-bus';

import state from './state';
import actions from './actions';
import getters from './getters';
import mutations from './mutations';

export default {
	state,
	actions,
	getters,
	mutations,
	name: 'week',
	data: () => ({
		week: ''
	}),
	props: {
		name: {
			type: String,
			default: 'week'
		},
		label: {
			type: String,
			default: 'Semana'
		},
		required: {
			type: Boolean,
			default: true
		},
		group: {
			type: Boolean,
			default: true
		},
		disabled: {
			type: Boolean,
			default: true
		},
		showFirst: {
			type: Boolean,
			default: true
		}
	},
	computed: {
		...mapGetters([
			'currentYear',
			'currentMonth',
			'currentWeek',
			'weeks'
		])
	},
	methods: {
		...mapActions([
			'putWeekList',
			'putCurrentWeek',
		]),
		changed() {

			this.putCurrentWeek(this.week);
			EventBus.$emit(`${ this.name }Changed`, this.week);

		},
		getMonthWeeks(year, month) {

			if (year && month >= 0) {

				const weeks = [];
				const baseDate = moment().set({
					'year': year,
					'month': month,
					'date': 1
				});
				const monthWeeks = Math.ceil(baseDate.daysInMonth() / 7);

				let currentDate = baseDate;

				if (month === 1) {
					monthWeeks + 1;
				}

				for (let week = 0; week < monthWeeks; week++) {

					weeks.push({
						startDate: cloneDeep(currentDate).startOf('week').format('YYYY-MM-DD'),
						endDate: cloneDeep(currentDate).endOf('week').format('YYYY-MM-DD')
					});

					currentDate = currentDate.add(1, 'w');

				}

				return weeks;

			}

		}
	},
	mounted() {

		if (!isEmpty(this.currentWeek)) {
			this.week = this.currentWeek;
		}

		this.putWeekList(
			this.getMonthWeeks(this.currentYear, this.currentMonth.index)
		);

		EventBus.$on('updateWeekList', (payload) => {

			if (payload.year && payload.month) {

				this.week = '';
				this.putWeekList(
					this.getMonthWeeks(payload.year, payload.month.index)
				);
				this.putCurrentWeek({});

			} else {
				this.putWeekList([]);
			}

		});

	},
	beforeDestroy() {

		EventBus.$off('updateWeekList');

	}
};



// WEBPACK FOOTER //
// ./sources/components/calendar/week/index.js